import { useEffect } from "react";
import { TileLayer, useMap } from "react-leaflet";
import { leafletLayer } from "protomaps-leaflet";

// Protomaps vector basemap, "black" flavor (the data-viz dark style from
// maps.protomaps.com). Set REACT_APP_MAP_TILES_URL to either a Protomaps API
// tile template or a self-hosted .pmtiles file — see docs/SETUP_MAP.md.
// Unset, the app falls back to plain OpenStreetMap raster tiles, which the
// .dark-map CSS filter darkens as before.
const TILES_URL = process.env.REACT_APP_MAP_TILES_URL;

export default function MapTiles() {
  const map = useMap();

  useEffect(() => {
    if (!TILES_URL) return undefined;
    const layer = leafletLayer({
      url: TILES_URL,
      flavor: "black",
      lang: "de",
      attribution:
        '<a href="https://protomaps.com">Protomaps</a> © <a href="https://openstreetmap.org">OpenStreetMap</a>',
    });
    layer.addTo(map);
    return () => {
      map.removeLayer(layer);
    };
  }, [map]);

  if (TILES_URL) return null;
  return (
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
  );
}
